import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { AssetAvailabilityScheduleService } from 'app/_services/asset-availability-schedule.service';
import { AddAvailabilityModalComponent } from 'app/shared-pages/site-pages/site-assets/asset-page/add-availability-modal/add-availability-modal.component';
import { EditAvailabilityModalComponent } from 'app/shared-pages/site-pages/site-assets/asset-page/edit-availability-modal/edit-availability-modal.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'all-site-schedule',
  templateUrl: './all-site-schedule.component.html'
})
export class AllSiteScheduleComponent implements OnInit {
  public response: any;

  public filters: { key: string; value: string; }[];
  public startTime: Date;
  public endTime: Date;
  public hoursPerColumn = 1;
  private siteOwnerIds: number[] = [];
  public routeRole: any;
  public noResultsMessage = false;

  constructor(
    private assetAvailabilityScheduleService: AssetAvailabilityScheduleService,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private globals: Globals,
  ) {
  }

  ngOnInit() {
    this.routeRole = this.globals.user.routeRole;

    if (this.routeRole === 'admin' || this.routeRole === 'support') {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.siteOwnerIds = [parseInt(params.siteOwnerId)];
      });
    } else {
      this.siteOwnerIds = this.globals.siteOwnerUsers.map(sou => sou.skylarkUserId);
    }
  }

  // in most cases there will only be one site owner id, but catering for multiple and combining the sites into one array
  public fetchResults() {
    this.response = null;

    let requests = [];
    for (let i = 0; i < this.siteOwnerIds.length; i++) {
      const siteOwnerId = this.siteOwnerIds[i];

      requests.push(
        this.assetAvailabilityScheduleService.getAllAvailabilityItemsBySiteOwner(siteOwnerId, this.filters)
      );
    }

    forkJoin(requests).subscribe((allData: any[]) => {
      this.response = {
        sites: allData.reduce((mergedSites, data) => mergedSites.concat(data.sites), [])
      };

      if (this.response.sites.length < 1) {
        this.noResultsMessage = true;
      }
    });
  }

  public onFiltersChanged(event) {
    this.filters = event.filters;
    this.hoursPerColumn = event.hoursPerColumn;
    this.startTime = event.startTime;
    this.endTime = event.endTime;

    this.fetchResults();
  }

  onGridClick(event) {
    const modalOptions: NgbModalOptions = { centered: true, backdrop: 'static' };
    const modal = this.modalService.open(AddAvailabilityModalComponent, modalOptions);
    modal.componentInstance.assetId = event.assetId;
    modal.componentInstance.startDate = event.date;

    const endDate = new Date(event.date);
    endDate.setHours(endDate.getHours() + this.hoursPerColumn);
    modal.componentInstance.endDate = endDate;

    modal.result.then(result => {
      if (result === 'refresh') {
        this.fetchResults();
      }
    }).catch(() => { /* modal dismissed */ });
  }

  onBookingClick(event) {
    const modalOptions: NgbModalOptions = { centered: true, backdrop: 'static' };
    const modal = this.modalService.open(EditAvailabilityModalComponent, modalOptions);
    modal.componentInstance.scheduleItem = event.booking;
    modal.componentInstance.assetId = event.assetId;

    modal.result.then(result => {
      if (result === 'refresh') {
        this.fetchResults();
      }
    }).catch(() => { /* modal dismissed */ });
  }
}
